var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMountain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "maki:mountain"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.99995 1.20001C8.63995 1.20001 8.51995 1.44001 8.27995 1.68001L1.31995 13.08C1.19995 13.2 1.19995 13.44 1.19995 13.56C1.19995 14.16 1.67995 14.4 2.03995 14.4H15.96C16.44 14.4 16.8 14.16 16.8 13.56C16.8 13.32 16.8 13.32 16.68 13.08L9.83995 1.68001C9.59995 1.44001 9.35995 1.20001 8.99995 1.20001ZM8.99995 3.00001L12.96 9.60001H12L10.2 7.80001L8.99995 9.60001L7.79995 7.80001L5.99995 9.60001H4.91995L8.99995 3.00001Z",
    fill: "#27346A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain);
export default __webpack_public_path__ + "static/media/mountain.4a747a8cbf7ffccf4520b8c825edb1d4.svg";
export { ForwardRef as ReactComponent };